// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__lKEax","tab":"Tabs_tab__zKhSM","tabActive":"Tabs_tabActive__XdF7x"};